import commonPageService from 'pcCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import './reset.css';
import './btn-new.css';
import './style.css';
import './home-common.css';

const init = () => {
    commonPageService({ renderAfter: syncRender });
};

init();
